import { addDoc, collection, deleteDoc, doc, getDocs, orderBy, query, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "./firebase";

const COLLECTION_NAME = "runningSessionLibrary";

const cleanSegment = (segment = {}) => ({
    type: "running_segment",
    segmentType: segment.segmentType || "run",
    label: segment.label || "",
    reps: segment.reps || 1,
    durationType: segment.durationType || "distance",
    distance: segment.distance || "",
    distanceUnit: segment.distanceUnit || "km",
    duration: segment.duration || "",
    targetType: segment.targetType || "pace",
    targetPaceMin: segment.targetPaceMin || "",
    targetPaceMax: segment.targetPaceMax || "",
    heartRateZone: segment.heartRateZone || "",
    powerZone: segment.powerZone || "",
    effortZone: segment.effortZone || "z2",
    cadenceTarget: segment.cadenceTarget || "",
    restAfter: segment.restAfter || "",
    terrain: segment.terrain || "flat",
    notes: segment.notes || "",
    paceGroups: segment.paceGroups || [],
    paceGroupTargets: segment.paceGroupTargets || [],
    paceGroupTargetsById: segment.paceGroupTargetsById || {},
});

const cleanBlock = (block = {}) => ({
    name: block.name || "Bloco",
    workoutType: "running",
    blockType: block.blockType || "main",
    repeat: block.repeat || 1,
    restBetweenRepeats: block.restBetweenRepeats || "",
    sessionType: block.sessionType || "",
    locationType: block.locationType || "",
    terrain: block.terrain || "",
    routeName: block.routeName || "",
    description: block.description || "",
    sets: (block.sets || []).map(cleanSegment),
});

const cleanSession = (session = {}) => ({
    name: session.name || "",
    group: session.group || "club",
    sessionType: session.sessionType || "easy",
    objective: session.objective || "",
    level: session.level || "",
    estimatedDistanceKm: session.estimatedDistanceKm || "",
    estimatedDurationMin: session.estimatedDurationMin || "",
    locationType: session.locationType || "",
    terrain: session.terrain || "",
    tags: session.tags || [],
    coachNotes: session.coachNotes || "",
    clubSession: session.clubSession || null,
    cyclePlan: session.cyclePlan || null,
    attendancePlan: session.attendancePlan || null,
    blocks: (session.blocks || []).map(cleanBlock),
});

const RunningSessionLibraryService = {
    getAll: async (idTenant) => {
        if (!idTenant) return [];

        const q = query(
            collection(db, "tenants", idTenant, COLLECTION_NAME),
            orderBy("createdAt", "desc")
        );
        const snapshot = await getDocs(q);
        return snapshot.docs.map(doc => ({ id: doc.id, source: "tenant", ...doc.data() }));
    },

    save: async ({ idTenant, authUser, session }) => {
        if (!idTenant) throw new Error("ID do Tenant é obrigatório.");
        if (!session?.name?.trim()) throw new Error("Nome da sessão é obrigatório.");

        const payload = {
            session: cleanSession(session),
            name: session.name.trim(),
            group: session.group || "club",
            createdAt: serverTimestamp(),
            createdBy: {
                uid: authUser?.uid || "system",
                name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema",
            },
        };

        const docRef = await addDoc(collection(db, "tenants", idTenant, COLLECTION_NAME), payload);
        return { id: docRef.id, source: "tenant", ...payload };
    },

    update: async ({ idTenant, sessionId, session }) => {
        if (!idTenant || !sessionId) throw new Error("Tenant e sessão IDs são obrigatórios.");
        if (!session?.name?.trim()) throw new Error("Nome da sessão é obrigatório.");

        const payload = {
            session: cleanSession(session),
            name: session.name.trim(),
            group: session.group || "club",
            updatedAt: serverTimestamp(),
        };

        await updateDoc(doc(db, "tenants", idTenant, COLLECTION_NAME, sessionId), payload);
        return { id: sessionId, source: "tenant", ...payload };
    },

    delete: async ({ idTenant, sessionId }) => {
        if (!idTenant || !sessionId) throw new Error("Tenant e sessão IDs são obrigatórios.");
        await deleteDoc(doc(db, "tenants", idTenant, COLLECTION_NAME, sessionId));
        return true;
    },
};

export default RunningSessionLibraryService;
